const tabs = {
    get_started: 'Начало',
    dashboard: 'Панель управления',
    applications: 'Приложения',
    api_resources: 'Ресурсы API',
    sign_in_experience: 'Опыт входа в систему',
    connectors: 'Коннекторы',
    webhooks: 'Webhooks',
    users: 'Управление пользователями',
    audit_logs: 'Журналы аудита',
    roles: 'Роли',
    docs: 'Документация',
    contact_us: 'Свяжитесь с нами',
    settings: 'Настройки',
};
export default tabs;
